exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh2.title-anchor[data-v-65ca46a7] {\n  padding-top: 100px;\n  margin-top: -100px;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/profile/profile-child-notification/styles.scss"],"names":[],"mappings":";AAAA;EACI,mBAAkB;EAClB,mBAAkB;CACrB","file":"styles.scss","sourcesContent":["h2.title-anchor {\n    padding-top: 100px; \n    margin-top: -100px;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65ca46a7","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/profile/profile-child-notification/styles.scss
// module id = GCTr
// module chunks = 0